export default{
    apiKey: "AIzaSyDhDC_UzMZ5qjsDvnC_hQWGx1Px-Y4s03o",
    authDomain: "vuefs-prod-418c8.firebaseapp.com",
    databaseURL: "https://vuefs-prod-418c8.firebaseio.com",
    projectId: "vuefs-prod-418c8",
    storageBucket: "vuefs-prod-418c8.appspot.com",
    messagingSenderId: "521365352888"
}


// WEBPACK FOOTER //
// ./client/components/firebase/firebaseConfig.js